import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String',
	'date_start': 'String!',
	'date_end': 'String!',
	'translations': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation app_message( ${ HelperGraphql.createFields( fields ) } ) {
	    app_message( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	    }
	}
`);

